import { EVENT_SEARCH_MODAL_LOADING } from "../constants";

export default function propagateSearchModalLoading() {
  // Check if we are in the client
  if (typeof window !== "object" || typeof CustomEvent !== "function") {
    console.warn(
      "[Search-ui] Calling search modal loading on a server function, ignoring request...",
    );
    return;
  }

  const event = new CustomEvent(EVENT_SEARCH_MODAL_LOADING, {
    detail: {
      timestamp: Date.now(),
    },
  });

  window.dispatchEvent(event);
}
